import { useLenis } from "@/hooks/useLenis";
import { useSEO } from "@/components/site/SEO";
import { SITE } from "@/config/site";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { FloatingCTA } from "@/components/site/FloatingCTA";
import { Marquee } from "@/components/site/Marquee";
import { Hero } from "@/sections/Hero";
import { Services } from "@/sections/Services";
import { Pricing } from "@/sections/Pricing";
import { Included } from "@/sections/Included";
import { HowItWorks } from "@/sections/HowItWorks";
import { WhyChoose, Combined } from "@/sections/WhyChooseCombined";
import { TrustedTeam } from "@/sections/TrustedTeam";
import { CommercialCallout } from "@/sections/CommercialCallout";
import { ServiceAreas } from "@/sections/ServiceAreas";
import { FAQ } from "@/sections/FAQ";
import { About } from "@/sections/ReviewsAbout";
import { Contact } from "@/sections/Contact";

export default function Home() {
  useLenis();
  useSEO({
    title: "End of Tenancy Cleaning Dublin | GoCleaning Dublin",
    description:
      "Professional end-of-tenancy and move-out cleaning for apartments and houses across Dublin and Kildare. Send photos for a fast, clear quote.",
    canonical: SITE.url + "/",
  });

  return (
    <div className="App bg-white">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Pricing />
        <Included />
        <HowItWorks />
        <WhyChoose />
        <TrustedTeam />
        <Combined />
        <CommercialCallout />
        <ServiceAreas />
        <FAQ />
        <About />
        <Contact />
      </main>
      <Footer />
      <FloatingCTA />
    </div>
  );
}
